export default __webpack_public_path__ + "static/media/person.2f13061c.svg";